









































import { defineComponent, PropType, inject, reactive } from '@vue/composition-api';
import StatusBoardCharacterParameter from '@/components/statusBoard/StatusBoardCharacterParameter.vue';
import StatusBoardCharacterPart from '@/components/statusBoard/StatusBoardCharacterPart.vue';
import StatusBoardCharacterEditDialog from '@/components/statusBoard/StatusBoardCharacterEditDialog.vue';
import StatusBoardCharacterRemoveDialog from '@/components/statusBoard/StatusBoardCharacterRemoveDialog.vue';
import { Character } from '@/types/statusBoard';
import { StatusBoardStoreModule, StatusBoardStoreModuleKey } from '@/modules/statusBoard/store';

export default defineComponent({

  components: { StatusBoardCharacterParameter, StatusBoardCharacterPart, StatusBoardCharacterEditDialog, StatusBoardCharacterRemoveDialog },

  props: {
    character: { type: Object as PropType<Character>, required: true }
  },

  setup () {
    const { removeCharacter, updateCharacter } = inject(StatusBoardStoreModuleKey) as StatusBoardStoreModule;

    const localState = reactive({
      editDialog: false,
      removeDialog: false
    });

    return {
      localState,
      removeCharacter,
      updateCharacter
    };
  }
});
